import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'content-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContentHeaderComponent {
  @Input() content?: any;

  constructor() {}
}
